// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1NB1paWya29uNgrOmgjNyw{position:relative;width:100%}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "_1NB1paWya29uNgrOmgjNyw"
};
module.exports = ___CSS_LOADER_EXPORT___;
